import { useEffect, useRef, useState } from "react";

const useStickyObserver = () => {
    const ref = useRef<HTMLDivElement>(null);
    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const observer = new IntersectionObserver(([entry]) => setSticky(!entry.isIntersecting), { threshold: [1] });
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return { ref, isSticky };
};

export default useStickyObserver;
